// extracted by mini-css-extract-plugin
export default {"searchWrapper":"MergeRightHeader_searchWrapper__nj-aL","search-box":"MergeRightHeader_search-box__da0Qd","title":"MergeRightHeader_title__qJOWt"};